import React, { useMemo } from 'react'
import AssistChip from 'components/Luxkit/Chips/AssistChip'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'

interface Props {
  inclusion: App.PackageInclusion
  size: 'small' | 'medium' | 'large'
  variant?: 'filled' | 'outline'
}

function OfferInclusionChipItem({ inclusion, size, variant = 'outline' }: Props) {
  const Icon = useMemo(() => getOfferFeatureIcon(inclusion.symbol), [inclusion])

  return (
    <AssistChip
      variant={variant}
      size={size}
      startIcon={<Icon />}
    >
      {inclusion.description}
    </AssistChip>
  )
}

export default OfferInclusionChipItem
